import { type ComponentProps, useMemo } from 'react';
import { Typography } from '@banhala/ui-kit';
import { renderHTMLToText } from '../utils';

type TypographyProps = ComponentProps<typeof Typography>;

type HTMLTextProps = Omit<TypographyProps, 'children'> & {
  children: string;
};

export const HTMLText = ({ children, ...typographyProps }: HTMLTextProps) => {
  const parsedChildren = useMemo(() => {
    const hasHTMLTag = children.includes('<');
    if (hasHTMLTag) {
      return renderHTMLToText(children);
    }
    return children;
  }, [children]);

  return <Typography {...typographyProps}>{parsedChildren}</Typography>;
};
